import Mock, { Random } from 'mockjs';
import MockRequest, { AjaxDate } from '../MockRequest';

export function getPreviewData(data: AjaxDate) {
  console.log(data);
  return new MockRequest(
    Mock.mock(
      {
        [`data|${Random.integer(1, 7)}`]: [{
          assignmentId: '@guid',
          id: '@guid',
          moduleName: '@cword(2,10)',
          seq: '@integer(0,7)',
          [`questionList|${Random.integer(1, 8)}`]: [{
            id: '@guid',
            score: '@integer(1,100)',
            stuScore: '@integer(1,50)',
            questionTitle: '@cword(2,10)',
            questionType: '@integer(0,3)',
            metas: JSON.stringify(
              ['@cword(2,10)', '@cword(2,10)', '@cword(2,10)', '@cword(2,10)'],
            ),
            // [`A-${Mock.mock('@ctitle')}`, `B-${Mock.mock('@ctitle')}`, `C-${Mock.mock('@ctitle')}`, `D-${Mock.mock('@ctitle')}`],
            analysis: '<p>@cword(2,300)</p>',
            answer: JSON.stringify([`${[0, 1, 2, 3][Mock.mock('@integer(0, 3)')]}`]),
          }],
        }],
      },
    ), '请求成功', true,
  );
}

export function test() { return {}; }
